import { createHttpLink } from '@apollo/client';
import config from 'config';

export const httpLink = createHttpLink({
  uri: config.splitTestsApiUri,
});
